import { PersonaGroupList } from '@/modules/group/modules/groups/domain/models/PersonaGroupList'

import { axios, Response } from '../../index'

const getMyGroups = (personaId: string): Response<PersonaGroupList> => {
  return axios.get(`/v1/personas/${personaId}/groups`)
}

export default getMyGroups
